module.exports = __webpack_public_path__ + "static/img/ic_close.9cfd2465.png";